import styled from 'styled-components';

const Label = styled.h2`
    margin: 0;
    display: flex;
    font-size: 1em;
    justify-content: space-around;
    width: 20%;
    align-items: center;
`;

export default Label;
